import React from 'react'
import {Query} from 'react-apollo'

import NotificationList from './NotificationList'
import Loading from '../Loading'

import query from '../../../queries/server/notifications'

const NotificationListContainer = ({office_id, onEdit, canEdit, onDelete, canDelete}) => {
  return(
    <Query query={query} variables={{office_id}}>
      {({data, loading}) => {
        if(loading) return <Loading/>

        return <NotificationList onEdit={onEdit} canEdit={canEdit} onDelete={onDelete} canDelete={canDelete} data={data.notifications}/>
      }}
    </Query>
  )
}

export default NotificationListContainer